import React, { Component } from "react";
import axios from "axios";
import { authService } from "../../../auth";
import OwlCarousel from 'react-owl-carousel';
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import * as _ from "lodash";
import { getCDNUrl } from "../../../commons/CommonFunctions";
class ProjectTopContributorSection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userData: authService.getUserDetailsFromLocalStorage(),
            topContributorList: {}
        }
    }

    getProjectTopContributors = () => {
        axios({
            method: 'GET',
            url: `${process.env.REACT_APP_userServiceURL}/project/topcontributor?userId=${this.state.userData.userId}&projectId=${this.props.entityId}`,
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true
        }).then(response => {
            if (response && response.data && response.data.body && response.data.message === 'Success!') {
                this.setState({
                    topContributorList: response.data.body
                })
            }
        }).catch((err) => {
            console.log(err);
        });
    }

    getOptimizedImage = (user) => {
        if(user.personalInfo && user.personalInfo?.profileImage) {
            if (user.personalInfo.resizedProfileImages && user.personalInfo.resizedProfileImages['200x200'] != null) {
                return user.personalInfo.resizedProfileImages['200x200'];
            }
            return user.personalInfo.profileImage;
        } else {
            return user.type === "INDIVIDUAL" ? "https://cdn.dscovr.com/images/users1.webp" : "https://cdn.dscovr.com/images/DefaultBusiness.webp";
        }
    }

    getCircleOptimizedImage = (circleInfo) =>{
        if(circleInfo.imageUrl) {
            if (circleInfo.resizedProfileImages && circleInfo.resizedProfileImages['300x300'] != null) {
                return circleInfo.resizedProfileImages['300x300'];
            }
            return circleInfo.imageUrl;
        } else {
            return "https://cdn.dscovr.com/images/circleDefault.webp";
        }
        
    }

    getOptimizedCoverImage = (personalInfo) => {
        let image = "https://cdn.dscovr.com/images/prof-banner.webp";
        if(personalInfo.coverImage){
            image =   personalInfo.coverImage;
        }
        return image;
    }

    redirectToDetailsPage = (user) => {
        window.location.href = !user.type ? `/community/${user.customUrl}` : `/profile/${user.customUrl}`;
    }

    componentDidMount() {
        this.getProjectTopContributors();
    }

    render() {
        const { topContributorList } = this.state;
        return (
            <>
                {topContributorList && topContributorList.length > 0 &&
                    <div className="prjHmCommonSec prjHmTopContributr topContributBlk">
                        <h2>Top Active Users</h2>
                        <OwlCarousel
                            id={"contributCarousel"}
                            className={"contributCarousel"}
                            autoWidth={true}                                        
                            dots={false}
                            margin={11}
                            items={4}
                            loop={false}
                            rewind={true}
                            nav={topContributorList && topContributorList.length > 4 ? true : false}
                            navText= {["<i class='iArrow_Left'></i>", "<i class='iArrow_Right'></i>"]}>
                                {topContributorList && topContributorList.map((user) => {
                                    return (
                                        <div className='item'>
                                            <div className="youmayknow itemBox">
                                                <div className= {"invitpeopleblk" + (user.type === "COMPANY" ? " orgnzName" : "")}>
                                                    <div className="bannImgbx">
                                                        <img src={(user.type === "INDIVIDUAL" || user.type === "COMPANY") ? getCDNUrl(this.getOptimizedCoverImage(user.personalInfo)) : getCDNUrl(user?.coverImage ? user?.coverImage : "https://cdn.dscovr.com/images/prof-banner.webp")}  alt="" />
                                                        <figure className="users" onClick={(e) => this.redirectToDetailsPage(user)} style={{cursor: "pointer"}}>
                                                            <img src={(user.type === "INDIVIDUAL" || user.type === "COMPANY") ? getCDNUrl(this.getOptimizedImage(user)) : getCDNUrl(this.getCircleOptimizedImage(user))} alt="" />
                                                        </figure>
                                                    </div>
                                                    <div className="youmayknbottinfo">
                                                        <div className="youmayknbottinfoTop">
                                                            <h5 onClick={(e) => this.redirectToDetailsPage(user)} style={{cursor: "pointer"}}>{user.username}</h5>
                                                            <p>
                                                                {user.persona && <span className="brif">{user.persona}</span>}
                                                                {!_.isEmpty(user.addressDetail) && <span className="address">{user.addressDetail?.country}</span>}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                        </OwlCarousel>
                    </div>
                }
            </>
        )
    }
}

export default ProjectTopContributorSection;